import React, { useState } from 'react';
import cn from 'classnames';
import { Carousel, Icon } from 'zarm';
import './index.less';

function renderButton(button = [], events) {
  const [first = {}] = button;
  const {
    imageUrl = ''
  } = first;
  const style = {
    backgroundImage: `url(${imageUrl})`
  }; // const onClick = getLocalClick(events);

  const onClick = () => {// console.log('evenet:', events);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "banner-button",
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    className: "img",
    style: style
  }));
}

function renderItems(imgs, videos) {
  let imgItems = [];
  let videoItems = [];
  let ret;

  if (imgs && imgs.length) {
    imgItems = imgs.map((item, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: `img${index}`,
        className: "banner-item"
      }, /*#__PURE__*/React.createElement("img", {
        src: item.imageUrl,
        alt: ""
      }));
    });
  }

  if (videos && videos.length) {
    videoItems = videos.map((item, index) => {
      return /*#__PURE__*/React.createElement(Video, {
        key: `videos${index}`,
        src: item.imageUrl,
        poster: item.thumbnail
      });
    });
  }

  ret = imgItems.concat(videoItems);

  if (!ret.length) {
    ret = /*#__PURE__*/React.createElement("div", {
      className: "banner-item"
    });
  }

  return ret;
}

function Video({
  src,
  className
}) {
  const [play, setPlay] = useState(false);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(className, 'banner-item')
  }, /*#__PURE__*/React.createElement("video", {
    preload: "preload",
    src: src,
    onClick: e => {
      setPlay(false);
      e.target.pause();
    }
  }, /*#__PURE__*/React.createElement("track", {
    kind: "captions"
  })), /*#__PURE__*/React.createElement("div", {
    className: cn({
      play: 1,
      hide: play
    }),
    onClick: e => {
      e.target.previousSibling.play();
      setPlay(true);
    }
  }));
}

function Features({
  data
}) {
  if (!data || !data.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement("ul", {
    className: cn('features', {
      'features--single': data.length === 1
    })
  }, data.map((item, index) => /*#__PURE__*/React.createElement("li", {
    key: index
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "right-round",
    theme: "primary",
    size: "sm"
  }), item)));
}

export default function Banner(props) {
  const {
    attrs = {}
  } = props;
  const {
    imgs,
    videos,
    button,
    events,
    features
  } = attrs;
  const items = renderItems(imgs, videos);
  const cls = cn({
    'c-banner': true,
    'button-banner': !!button
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "banner"
  }, /*#__PURE__*/React.createElement("div", {
    className: cls
  }, items.length > 1 ? /*#__PURE__*/React.createElement(Carousel, {
    autoPlay: true,
    loop: true,
    direction: "left"
  }, items) : items[0], renderButton(button, events)), /*#__PURE__*/React.createElement(Features, {
    data: features
  }));
}